'use client';

import { useRef } from 'react';

// 스크롤 최초 진입 시 등장할 "초기 카드 집합"을 마운트 시점에 한 번만 캡처한다.
// 초기 등장 대상 = 그 순간 중앙(active)의 양옆 ±1..±interactiveOffset 카드.
// 반환된 함수 shouldRun(j)는 그 카드가 등장 애니메이션 대상인지 알려준다.
// 등장 시작 후 캐러셀 이동으로 새로 들어온 카드는 제외(즉시 표시)하기 위함이며,
// 판단 근거(초기 집합)를 부모가 명시적으로 보유해 CardEntrance는 순수 prop 기반으로 유지된다.
export function useEntranceReveal(active: number, interactiveOffset: number) {
  const initialSet = useRef<Set<number> | null>(null);

  if (initialSet.current === null) {
    const set = new Set<number>();
    for (let k = 1; k <= interactiveOffset; k++) {
      set.add(active - k);
      set.add(active + k);
    }
    initialSet.current = set;
  }

  return (j: number) => initialSet.current!.has(j);
}
